import ChatbotLogo from "../../../../../../assets/images/chatbot/chatbot-logo.png";

import "./ExchangeAiAvatar.scss";

export const ExchangeAiAvatar = () => {
  return (
    <div className="exchange-ai-avatar">
      <img src={ChatbotLogo} className="icon" alt="AI Avatar" />
      <label>KIRA</label>
    </div>
  );
};
